// 네비게이션 페이지 타입 정의
export type PageName = 'DASHBOARD' | 'REVIEWS' | 'ORGANIZATION' | 'REVIEW_BOOSTER' | 'REVIEW_BOOSTER_LANDING' | 'ENTERPRISE' | 'BLOG' | 'MEDICONTENTS' | 'MEDICONTENTS_LANDING';

// 네비게이션 아이템 상수
export const PAGE_NAME = {
  DASHBOARD: 'DASHBOARD',
  REVIEWS: 'REVIEWS',
  ORGANIZATION: 'ORGANIZATION',
  REVIEW_BOOSTER: 'REVIEW_BOOSTER',
  REVIEW_BOOSTER_LANDING: 'REVIEW_BOOSTER_LANDING',
  ENTERPRISE: 'ENTERPRISE',
  BLOG: 'BLOG',
  MEDICONTENTS: 'MEDICONTENTS',
  MEDICONTENTS_LANDING: 'MEDICONTENTS_LANDING'
} as const;

// 네비게이션 라벨 정의
export const PAGE_LABEL = {
  [PAGE_NAME.ENTERPRISE]: '제품소개',
  [PAGE_NAME.DASHBOARD]: '대시보드',
  [PAGE_NAME.REVIEWS]: '리뷰 리스트',
  [PAGE_NAME.REVIEW_BOOSTER]: '대시보드',
  [PAGE_NAME.REVIEW_BOOSTER_LANDING]: '제품소개',
  [PAGE_NAME.ORGANIZATION]: '조직 관리',
  [PAGE_NAME.BLOG]: '블로그',
  [PAGE_NAME.MEDICONTENTS]: '메디컨텐츠',
  [PAGE_NAME.MEDICONTENTS_LANDING]: '제품소개'
};
